import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormattedMessage, defineMessages } from 'react-intl';
import Header from '../../components/Header';

import NoResults from './repvisits-your-schedule-no-results';
import Appointments from './repvisitis-your-schedule-appointments';
import RepVisitsWeekOf from '../RepVisitsSearchPage/repvisits-week-of';

import './styles.css';

const messages = defineMessages({
  yourSchedule: {
    id: 'repvisits.overview.yourSchedule',
    defaultMessage: 'Your Schedule',
  },
});

class RepVisitsYourSchedule extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    params: PropTypes.shape({
      fromDate: PropTypes.instanceOf(Date),
      toDate: PropTypes.instanceOf(Date),
    }),
  };

  render() {
    const { params: { fromDate, toDate } = {}, viewer } = this.props;
    return (
      <div styleName="container">
        <div styleName="header-container">
          <div>
            <Header as="h2" styleName="item-header-schedule" id="pageTitle">
              <FormattedMessage {...messages.yourSchedule} />
            </Header>
            <p styleName="item-header-date">
              <RepVisitsWeekOf dateFrom={fromDate} dateTo={toDate} />
            </p>
          </div>
        </div>
        {!get(viewer, 'repVisitsSchedule.length') ?(
          <NoResults />
        ) : (
          <div>
            {viewer.repVisitsSchedule.map((repVisitsSchedule) => (
              <Appointments key={repVisitsSchedule.id} enabledFeatures={viewer.enabledFeatures} {...repVisitsSchedule} />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default RepVisitsYourSchedule;
